<template>
  <div class="mib-ad-container" v-on:click="openLink()">
    <img :src="mibAdImage" alt="mib-ad"/>
    <span class="mib-ad">{{ buttonName }}</span>
  </div>
</template>

<script>
  const MIB_AD_BASE_URL = 'https://mibcdn.blob.core.windows.net/mib-ads/portal-home-login'

  export default {
    name: 'MibAd',
    data() {
      return {
        buttonName: '',
        buttonURL: '',
      }
    },
    computed: {
      language() {
        return this.$i18n.locale()
      },
      mibAdImage() {
        return `${MIB_AD_BASE_URL}/ad-${this.language}.svg`
      },
    },
    watch: {
      language: {
        immediate: true,
        handler(language) {
          fetch(`${MIB_AD_BASE_URL}/ad-${language}.txt`, {cache: 'no-store'})
            .then(response => response.text())
            .then((content) => {
              const config = this.parseButtonSettings(content)
              this.buttonName = config.buttonName
              this.buttonURL = config.buttonURL
            })
            .catch((error) => {
              console.error('Failed to load mib-ad button config', error)
            })
        },
      },
    },
    methods: {
      parseButtonSettings(content) {
        const config = {buttonName: '', buttonURL: ''}

        content.split(/\r?\n/).forEach((line) => {
          const separatorIndex = line.indexOf('=')
          if (separatorIndex === -1) {
            return
          }
          const key = line.slice(0, separatorIndex).trim()
          const value = line.slice(separatorIndex + 1).trim()
          if (key === 'buttonName') {
            config.buttonName = value
          } else if (key === 'buttonURL') {
            config.buttonURL = value
          }
        })

        return config
      },
      openLink() {
        if (this.buttonURL) {
          window.open(this.buttonURL, '_blank', 'noopener,noreferrer')
        }
      },
    },
  }
</script>

<style lang="scss" scoped>
  .mib-ad-container {
    display: block;
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;
  }

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
    border-radius: inherit;
    transition: filter 0.3s ease;
  }

  /* Tooltip desktop */
  .mib-ad {
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 2;

    transform: translate(-50%, -40%);
    padding: 0.7rem 1.2rem;
    border-radius: 999px;

    background: #FFFFFF;

    color: #1E4FFF;
    font-size: 0.875rem;
    font-weight: 600;
    text-align: center;
    white-space: nowrap;

    opacity: 0;
    visibility: hidden;
    pointer-events: none;

    transition: opacity 0.3s ease, transform 0.3s ease, visibility 0.3s ease;
  }

  /* Hover desktop */
  @media (hover: hover) and (pointer: fine) {
    .mib-ad-container:hover .mib-ad {
      opacity: 1;
      visibility: visible;
      transform: translate(-50%, -50%);
    }

    .mib-ad-container:hover img {
      filter: brightness(0.8);
    }
  }

  /* Badge mobile dans le coin inférieur droit */
  @media (max-width: 55rem) {
    .mib-ad {
      top: auto;
      left: auto;
      right: 0;
      bottom: 0;

      transform: none;
      opacity: 1;
      visibility: visible;

      padding: 0.37rem 0.57rem;
      border-radius: 1rem 0 0 0;
      font-size: 0.72rem;
    }

    .mib-ad-container:hover .mib-ad {
      transform: none;
    }

    .mib-ad-container:hover img {
      filter: none;
    }
  }

  /* Petits mobiles */
  @media (max-width: 30rem) {
    .mib-ad {
      padding: 0.3rem 0.5rem;
      font-size: 0.64rem;
    }
  }
</style>
